import api from "../../api";
import { sanitizeIO, waitForLoggedIn, waitForRefreshToken, statusCodes, internalErrorCodes } from "@/utils/index";

const actions = {};

for (let key in api) {
	actions[key] = function({ dispatch, rootGetters }, apiArgs) {
		const apiFunc = api[key];
		const currentUser = rootGetters["session/username"];
		const options = {
			dispatch,
			rootGetters,
			apiFunc,
			apiArgs,
			currentUser
		};
		return runAction.call(options);
	};
}

function runAction() {
	return runRequestAndCleanupResponse.call(this)
		.catch(error => {
			if (error.status === 401) {
				return handleUnauthorizedError.call(this);
			} else {
				throw error;
			}
		});
}

function runRequestAndCleanupResponse() {
	return this.apiFunc(this.apiArgs)
		.then(response => {
			const sanitizedResponse = sanitizeIO(response);
			sanitizedResponse.$_localMeta = sanitizedResponse.$_localMeta || {};
			sanitizedResponse.$_localMeta.requestedBy = this.currentUser;
			return sanitizedResponse;
		});
}

function handleUnauthorizedError() {
	return waitForRefreshToken()
		.then(isFirstRequest => {
			if (isFirstRequest) {
				return refreshToken.call(this);
			}
		})
		.then(() => runRequestAndCleanupResponse.call(this))
		.catch(error => {
			if (error && (error.status === statusCodes.UNAUTHORIZED || error.code === internalErrorCodes.MISSING_TOKEN)) {
				return this.dispatch("session/setRefreshTokenRequestInactive", null, { root: true })
					.then(() => this.dispatch("session/logout", null, { root: true }))
					.then(() => waitForLoggedIn())
					.then(() => runRequestAndCleanupResponse.call(this));
			}
		});
}

function refreshToken() {
	return api.refreshToken()
		.then(() => this.dispatch("session/setRefreshTokenRequestInactive", null, { root: true }));
}

export default {
	namespaced: true,
	actions
};



// WEBPACK FOOTER //
// ./src/store/modules/request.js